export default "__VITE_ASSET__DQJhQs8z__"